import { TemplateCodeParameter } from "../ars_ldm";
import { isNamedObject } from "./isNamedObject";
import { isObjectRecord } from "./isObjectRecord";

/**
 * Type guard to check if a value is a TemplateCodeParameter.
 *
 * @param obj - The value to check.
 * @returns True if the value is a TemplateCodeParameter.
 */
export const isTemplateCodeParameter = (obj: unknown): obj is TemplateCodeParameter => {
  if (!isObjectRecord(obj)) return false;
  if (!isNamedObject(obj)) return false;

  if (
    typeof obj.valueSource !== "string" ||
    !["groupingFactor", "operation"].includes(obj.valueSource)
  )
    return false;

  if (
    obj.value !== undefined &&
    (!Array.isArray(obj.value) || obj.value.some((value) => typeof value !== "string"))
  )
    return false;

  if (
    typeof obj.parameterType !== "string" ||
    ![
      "string",
      "number",
      "boolean",
      "stringList",
      "numberList",
      "select",
      "multiSelect",
      "dataset.variable",
    ].includes(obj.parameterType)
  )
    return false;

  if (
    obj.availableValues !== undefined &&
    (!Array.isArray(obj.availableValues) ||
      obj.availableValues.some((value) => typeof value !== "string"))
  )
    return false;

  /* Everything is good */
  return true;
};
